import { z } from "zod";

export const CommunicationChannelSchema = z.enum({
  WHATSAPP: "WHATSAPP",
  EMAIL: "EMAIL",
});

export type CommunicationChannel = z.infer<typeof CommunicationChannelSchema>;

export const CommunicationChannel = CommunicationChannelSchema.enum;
